<!--商品详情-->
<template>
<div class="productDetailContent">
        <div class="page-item">
            <div class="content productshow">
                <div class="content-left">
                    <div class="infobox">
                        <div class="img">
                            <div class="mainimg">                                                        
                                <img :src="big"  :alt="product.name" />
                                <div class="playbtn"  v-if="defaultImg==big&&productVideo!=''&&productVideo!=null" @click="showVideo(productVideo, product.name+'视频')"></div>
                            </div>
                            <div class="imglist">
                                <ul>
                                    <li v-for="(item,i) in small" :key="i" :class="big==item?'on':''" @click="setBig(i)" v-if="i<6">
                                      <img :src="item" :alt="product.name">
                                    </li>                                  
                                </ul>
                            </div>
                            <div class="imgbottom">
                                <a>
                                    <i class="icon icon-start" v-if="!product.isCollect" @click="_collect(product.id)"></i>
                                    <i class="icon icon-start1" v-if="product.isCollect" @click="_removeCollect(product.id)"></i>
                                    收藏商品({{ this.product.collectNum}}人气)
                                </a>
                            </div>
                        </div>
                        <div class="info">
                            <div class="pDetail t">
                                {{product.name}}
                            </div>
                            <div class="pDetail tags" style="display:none">
                                <span>经典</span>
                                <span>潮流</span>
                            </div>
                             <div v-if="discountAmount>0" class="pDetail price">
                                <div class="price1" v-if="sellPrice!=settlementPrice" >优惠前：<span>￥{{sellPrice.toFixed(2)}}</span>
                                  <span class="price3">￥{{discountAmount.toFixed(2)}}</span><span class="price4">军人优待券<span>即时可用</span></span>                                
                                </div>
                                <div class="price2">券后：<span>￥{{settlementPrice.toFixed(2)}}</span></div>
                            </div>
                            <div v-else class="pDetail price">
                                <div class="price1" v-if="sellPrice!=settlementPrice" >原价：<span>￥{{sellPrice.toFixed(2)}}</span></div>
                                <div class="price2">售价：<span>￥{{settlementPrice.toFixed(2)}}</span></div>
                            </div>
                            <div class="pDetail sku" v-for="(item,i) in frontendPropertyInfo"  :key="i">
                                <div class="t">
                                  {{item.name}}：
                                </div>
                                <ul>
                                    <li v-for="(p,j) in item.propertyDetails"  :key="j" :class="(p.disable==true?'disableSpec ':'')+ (p.current==true?'on':'')"  @click="p.disable==true?selAttr1():selAttr(i,j)">
                                        {{p.name}}
                                    </li>                                    
                                </ul>
                            </div>                    
                            <div class="pDetail num">
                                <div class="t">
                                    数量：
                                </div>
                                <div class="numbox">
                                    <span @click="reduceNum">
                                        -
                                    </span>
                                    <input type="text" v-model="num"  @change="changeNum"/>
                                    <span @click="addNum">
                                        +
                                    </span>                                   
                                </div>
                                <div class="t">
                                  库存剩余({{stockNum}})
                                </div>
                            </div>
                            <div class="pDetail btns" :style="product.saleStatus!=0?'display:none;':''">
                                <a class="buy"  @click="checkout(product.id)">立即购买</a>
                                <a class="addcar" @click="addCart(product.id,settlementPrice,product.name,product.defaultImage)">加入购物车</a>
                            </div>
                        </div>
                    </div>
                    <div class="labelbox" v-if="product.labels&&product.labels.length>0" >
                      <div class="productLabel" v-for="(item,index) in product.labels" :key="index">
                       <div class="labelIcon"><img v-if="item.labelIcon" :src="item.labelIcon"/></div>
                       <div class="labelName" :title="item.description">{{item.labelName}}<span>{{item.description}}</span></div>
                       <hr v-if="(index%2==0&&(product.labels.length-index)>2)||index%2==1&&(product.labels.length-index)>=2" :class="(index)%2==0?'horizontal-left':'horizontal-right'" />
                      </div>                     
                      <div style=" clear: both;">                      
                      </div>
                    </div>
                    <div class="desbox">
                        <div class="nav">
                            <ul>
                                <li :class="describeType==0?'on':''" @click="setDescribe(0)">商品详情</li>
                                <li :class="describeType==1?'on':''" @click="setDescribe(1)">累积评价<span v-if="evaluateTotal>0">({{evaluateTotal}})</span></li>
                            </ul>
                        </div>
                        <div class="navbox">
                            <div v-if="describeType==0" class="navbox-content ql-editor" style="white-space:pre-wrap;" v-html="productMsg">
                            </div>
                            <div v-if="describeType==1" class="navbox-content">
                              <div v-for="(item,index) in evaluates" :key="index">
                                <div class="evaluateHead">
                                  <div class="evaluateAvatar">
                                    <img v-if="item.avatar" class="photo" :src="item.avatar" />
                                    <img v-else class="photo" src="https://file-sz.fjjykj.com.cn/Supply/sbc66de876f0ec3f951eaeab89ad80afb.png" />
                                    <img v-if="item.sex==0||item.sex==false" class="sex" title="女" src="https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png" />
                                    <img v-else class="sex" title="男" src="https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png" />
                                  </div>
                                  <div class="evaluateMember">
                                    <span>{{item.memberName}}</span><br/>     
                                    {{item.intervalTime}} <span v-if="!item.specName&&item.specName!='0'">{{item.specName}}</span>                      
                                  </div>
                                </div>
                               <div class="evaluateContent"> {{item.evaluateContent}}</div>
                               <div v-if="item.evaluatePictures&&item.evaluatePictures.length>0" class="evaluateImage"> 
                                  <img v-for="(item1,index1) in item.evaluatePictures" :key="index1" :src="item1" @click="showImage(item1,'评价图片')" />
                               </div>
                               <div v-if="item.addends&&item.addends.length>0" class="evaluateAddend"> 
                                  <div v-for="(item1,index1) in item.addends" :key="index1">
                                    <div class="evaluateReplyContent"><span>{{item1.intervalTime}}追评：</span>{{item1.evaluateContent}}</div>
                                    <div v-if="item1.evaluatePictures&&item1.evaluatePictures.length>0" class="evaluateImage"> 
                                      <img v-for="(item2,index2) in item1.evaluatePictures" :key="index2" :src="item2" @click="showImage(item2,'追评图片')"/>
                                    </div>
                                  </div>       
                               </div>
                               <div v-if="item.replys&&item.replys.length>0" class="evaluateReply"> 
                                  <div v-for="(item1,index1) in item.replys" :key="index1">
                                    <div class="evaluateReplyContent"><span>{{item1.intervalTime}}回复：</span>{{item1.evaluateContent}}</div>
                                    <div v-if="item1.evaluatePictures&&item1.evaluatePictures.length>0" class="evaluateImage"> 
                                      <img v-for="(item2,index2) in item1.evaluatePictures" :key="index2" :src="item2" @click="showImage(item2,'回复图片')"/>
                                    </div>
                                  </div>       
                               </div>
                               <div class="evaluateTail"></div>
                              </div>
                              <div class="evaluatePage">
                                <el-pagination
                                v-if="!noResult&&!error"
                                @current-change="handleCurrentChange"
                                :page-size="pageSize"
                                @size-change="handleSizeChange"
                                :current-page.sync="currentPage3"
                                layout="prev, pager, next, jumper"
                                :total="evaluateTotal">
                                </el-pagination>
                              </div>                              
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-right">
                    <div class="supplier" style="min-height: 228px;height: auto !important;" v-if="supplier">
                        <img v-if="supplier.supplierLogo" :src="supplier.supplierLogo"/>
                        <div class="supplierName">{{supplier.supplierName}}</div>
                        <div class="supplierLabel" v-if="supplier.labels">
                          <el-tag style="padding: 2px 5px 2px 5px; margin-left: 5px;margin-top: 2px; height: auto !important;background-color: #f0f9eb;border-color: #e1f3d8;color: #67c23a;" v-for="(item,index) in supplier.labels" :key="index">{{item.labelName}}</el-tag>
                        </div>
                        <div class="supplierBtn" @click="toSupplier"><div><img class="img1" src="http://file-sz.fjjykj.com.cn/Supply/se919e00d1de3930d887d67eebd282e15.png"/> <img class="img2" src="https://file-sz.fjjykj.com.cn/Supply/s3ddb52f022fb50f6fe82592174971b0d.png"></div></div>
                    </div>
                    <div class="title">商城热卖</div>
                    <ul>
                        <li v-for="(item,i) in productList" :key="i">
                                <img :src="item.defaultImage" @click="toDetail(item.id)"/>
                                <div>
                                    <span class="price1">
                                        ￥{{item.settlementPrice.toFixed(2)}}
                                    </span>
                                    <span class="price2">
                                        ￥{{item.sellPrice.toFixed(2)}}
                                    </span>
                                </div>
                                <div class="ptitle" @click="toDetail(item.id)">
                                    {{item.name}}
                                </div>                     
                        </li>                        
                    </ul>
                </div>
            </div>
        </div>
        <videoShow ref="videoShow"></videoShow>
        <imageShow ref="imageShow"></imageShow>
</div>
</template>
<style>
@import '../../styles/productDetail.css';
@import '../../styles/md-toolbar.scss';
@import '../../styles/vue2-editor.scss';
</style>
<script>
  import { getProducts, getProduct, collect, removeCollect, getProductEvaluates } from '@/api/productDetail'
  import api from '@/api'
  import { mapMutations, mapState } from 'vuex'
  import { getStore, setStore} from '@/utils/storage'
  import VideoShow from '@/components/VideoShow'
  import ImageShow from '@/components/ImageShow'
  export default {
    name: 'goodsDetails',
    data () {
      return {
        productMsg: {},
        currentsmall:[],
        small: [],
        smallIndex:0,
        big: '',
        defaultImg:'',
        product: {},
        settlementPrice:0,
        sellPrice:0,
        discountAmount:0,
        helpFund:0.00,
        num: 1,
        userId: '',
        sourceFrontendPropertyInfo:[],
        frontendPropertyInfo:[],
        stockNum:0,
        selectIndexArray:[],
        selectIdAttrray:[],
        productList:[],
        productVideo:'',      
        showGotop:false,
        describeType:0,
        evaluates:[],
        evaluateTotal:0,
        currentPage: 1,
        pageSize: 20,
        productId:0,
        supplier:{}
      }
    },
    computed: {
      ...mapState(['isLogined'])
    },
    methods: {
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
      showImage(url, title) {
        this.$refs['imageShow'].show(url, title)
     },
      async _collect(productId)
      {
        if(!this.isLogined)
        {
          this.$router.push({ name: 'userLogin' })
          return;
        }
        var _this=this;
        collect({id:productId}).then(res=>{
            _this.$message({ message: '收藏成功', type: 'success', customClass: 'c-msg' })            
            setTimeout(() => {
              location.reload();
            }, 500)
        });
      },
      async _removeCollect(productId)
      {
        if(!this.isLogined)
        {
          this.$router.push({ name: 'userLogin' })
          return;
        }
        var _this=this;
        removeCollect({id:productId}).then(res=>{          
            _this.$message({ message: '移除收藏成功', type: 'success', customClass: 'c-msg' })
            setTimeout(() => {
              location.reload();
            }, 500) 
        });
      },
      setDescribe(type)
      {
        this.describeType = type;
      },
      toDetail(id)
      {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      toSupplier()
      {
        window.location = '//' + window.location.host + '/#/search?searchType=0&&sLogo='+ this.supplier.supplierLogo+'&&sName='+ this.supplier.supplierName+'&&sId='+ this.supplier.supplierId
      },
      carouselImg()
      {
          this.smallIndex += 1;
          if(this.smallIndex>=6||this.smallIndex>=this.small.length)
          {
             this.smallIndex=0;
          }
         if(this.small.length>0&&this.small.length>this.smallIndex)  this.big = this.small[this.smallIndex];
         var _this = this;
         setTimeout(() => {
              _this.carouselImg()
            }, 5000)
      },
      setBig(index)
      {
        this.smallIndex=index;
        this.big = this.small[index];
      },
      _productDet () {
        var _this=this;
        getProduct({id:this.productId,isPC:true}).then(res => {
          if (res.data.success === true) {
            this.product = res.data.result
            this.supplier = res.data.result.supplier
            this.productMsg = res.data.result.description || ''
            this.small = res.data.result.productImages
            this.currentsmall = res.data.result.productImages
            this.settlementPrice = res.data.result.productSpecs[0].settlementPrice
            this.sellPrice = res.data.result.productSpecs[0].sellPrice
            this.discountAmount = res.data.result.productSpecs[0].discountAmount
            this.frontendPropertyInfo = this.product.frontendPropertyInfo
            this.productVideo = this.product.productVideo;
            this.stockNum =  this.product.productSpecs[0].quantity,
            this.helpFund = this.product.helpFund;
            this.big = this.small[0]
            this.defaultImg = this.small[0]          
            this.disableSpec()
            setTimeout(() => {
              _this.carouselImg()
            }, 5000)
          }
        })
      },
      showVideo(url, title) {
        this.$refs['videoShow'].show(url, title)
      },
      async _products()
      {
        var param = {
          sorting:'sales',
          skipCount: 0,
          maxResultCount: 5,
        };
        await getProducts(param).then(res=>{
          if (res.data.success === true) {
            this.productList = res.data.result.items;
          }
        });
      },
      handleSizeChange (val) {
        this.pageSize = val
        this._productEvaluates()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this._productEvaluates()
      },
      async _productEvaluates()
      {
        var param = {        
          ProductId:this.productId,
          SkipCount: this.currentPage,
          MaxResultCount: this.pageSize,
        };
        await getProductEvaluates(param).then(res=>{
          if (res.data.success === true) {
            this.evaluates = res.data.result.items;
            this.evaluateTotal = res.data.result.totalCount;
          }
        });
      },
      reduceNum()
      {
        this.num--;
        if(this.num<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
      },
      addNum()
      {
         this.num++;
        if(this.num>this.stockNum)
        {
          this.$message({ message: '数量不可大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=this.stockNum;
          return;
        }
      },
     changeNum()
     {      
      var myreg=/^\+?[1-9]\d*$/;
        if(!myreg.test(this.num))
        {
          this.$message({ message: '数量格式不对', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
      if(this.num==''||this.num==undefined|| parseInt(this.num)>this.stockNum)
        {
          this.$message({ message: '数量不可为空，且不得大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
        if(parseInt(this.num)<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
    },
      showTop(){
         this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
         
          if(this.scroll>500){
            this.showGotop = true
          }else{
            this.showGotop = false
          }
      },
      goTop(){
        console.log(2222)
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      addCart (id, price, name, img) {
        if(!this.isLogined)
        {
          this.$router.push({ name: 'userLogin' })
          return;
        }
        if(this.num<=0)
        {
          this.$message({ message: '请输入要购买的数量', type: 'error', customClass: 'c-msg' }) 
          return;
        }
        let specId= this.checkAttr()
        if(!specId){
           return
        }
        let specName = ''
        this.product.productSpecs.forEach((item) => {
          if (item.id === specId){
            specName = item.specName
          }
        })
        if (!this.showMoveImg) {     // 动画是否在运动
       
          this.ADD_CART({
            productId: id,
            settlementPrice: price,
            name: name,
            defaultImage: img,
            num: this.num,
            specId: specId,
            specName:specName,
            helpFund:this.helpFund
          })
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: img})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
          this.$message({ message: '加入购物车成功', type: 'success', customClass: 'c-msg' }) 
        }
      },
      checkout (productId) {
        if(!this.isLogined)
        {
          this.$router.push({ name: 'userLogin' })
          return;
        }
         let specId= this.checkAttr()
         if(!specId){
           return
         }      
       
        debugger
        let cartlist = [{
            productId: productId,
            settlementPrice: this.settlementPrice,
            name: this.product.name,
            defaultImage: this.product.defaultImage,
            num: this.num,
            specId: specId,
            checked:'1',
            helpFund : this.helpFund
          }]
        setStore('cartlist',cartlist)
        this.$router.push({path: '/checkout', query: {productId, num: this.num, isCart: false}})
      },
      editNum (num) {
         if(num <=0){
           num = 1
         }
        this.num = num
       
      },
      checkAttr(){

        var productSpecs = this.product.productSpecs; //原始规格数据
        //判断是否所以规格组都选中
        var frontendPropertyInfo = this.frontendPropertyInfo;
        var tips = ''
        var selectAttrid = []

        for (var i = 0; i < frontendPropertyInfo.length; i++) {
            if (this.selectIndexArray.indexOf(i) < 0) {
                tips = '请选择' + frontendPropertyInfo[i].name

            }
            var propertyDetails = frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                }
            }
        }
        if (tips) {
            this.showErrorMsg(tips)
            return false
        }

        var specId = 0;
        //从原始数据中找到相应规格组
        for (var i = 0; i < productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
                specId = productSpecs[i].id //规格id
                if (productSpecs[i].quantity <= 0) {
                    this.showErrorMsg('该规格库存不足')
                    return;
                }
            }
        }      
        if (specId == 0) {
          this.showErrorMsg('请选择规格')
          return false
        }      
        return specId 
      },
      disableSpec()
      {
        var count = this.frontendPropertyInfo.length;
        var product = this.product          
        if(count==1)
        {          
            var main = this.frontendPropertyInfo[0].propertyDetails;
            if(main&&main.length>0)
            {
               for(var m=0;m<main.length;m++)
               {
                  var sub = main[m] ;
                  var tempStockNum=0;
                  var tempselectAttrid=[];
                  tempselectAttrid.push(sub.id);

                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);}
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity;      
                      break;     
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                     this.frontendPropertyInfo[0].propertyDetails[m].disable = true;
                  }
                  else
                  {
                     this.frontendPropertyInfo[0].propertyDetails[m].disable = false;
                  }
               }
            }         
        }      
        if(count==2)
        {       
          for(var i=0;i<this.frontendPropertyInfo.length;i++)
          {
             for(var j=0;j<this.frontendPropertyInfo[i].propertyDetails.length;j++)
             {
               this.frontendPropertyInfo[i].propertyDetails[j].disable=false;
             }
          }
          if(this.selectIndexArray.length==1)
          { 
             var main = this.frontendPropertyInfo[0].propertyDetails;
             var main1 = this.frontendPropertyInfo[1].propertyDetails;
             var exist = main.find((p) => p.id==this.selectIdAttrray[0]);
             var exist1 = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             main.forEach(item=>{    
              var tempItemId  = this.selectIdAttrray[0];
              if(!exist) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                var tempItem1Id = this.selectIdAttrray[0];
                if(!exist1) {tempItem1Id = item1.id;};                 
                var tempselectAttrid=[];   
                tempselectAttrid.push(tempItemId);
                tempselectAttrid.push(tempItem1Id);

                var tempStockNum=0;
                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {  tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity                  
                      break;          
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                    if(exist) { item1.disable = true;   }
                    if(exist1) { item.disable = true;  }                   
                  }
                  else
                  {
                    if(exist) { item1.disable = false;  }
                    if(exist1) { item.disable = false;  }                    
                  }     
               });
             });   
          }
          if(this.selectIndexArray.length==2)          
          {            
              var main = this.frontendPropertyInfo[0].propertyDetails;
              var main1 = this.frontendPropertyInfo[1].propertyDetails;
              var existA = main.find((p) => p.id==this.selectIdAttrray[0]);
              var existA1 = main1.find((p) => p.id ==this.selectIdAttrray[0]);
              var existB = main.find((p) => p.id==this.selectIdAttrray[1]);
              var existB1 = main1.find((p) => p.id ==this.selectIdAttrray[1]);
              main.forEach(item=>{            
              var tempItemId  = this.selectIdAttrray[0];
              if(!existA) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                var tempItem1Id = this.selectIdAttrray[0];
                if(!existA1) {tempItem1Id = item1.id;};                 
                var tempselectAttrid=[];   
                tempselectAttrid.push(tempItemId);
                tempselectAttrid.push(tempItem1Id);
                var tempStockNum=0;             
                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity       
                      break;          
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                    if(existA) { item1.disable = true;   }
                    if(existA1) { item.disable = true;  }                   
                  }
                  else
                  {
                    if(existA) { item1.disable = false;  }
                    if(existA1) { item.disable = false;  }                    
                  }     
               });
             });
             main.forEach(item=>{            
              var tempselectAttrid=[];
             var tempItemId  = this.selectIdAttrray[1];
              if(!existB) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                var tempItem1Id = this.selectIdAttrray[1];
                if(!existB1) {tempItem1Id = item1.id;};                 
                var tempselectAttrid=[];   
                tempselectAttrid.push(tempItemId);
                tempselectAttrid.push(tempItem1Id);

                var tempStockNum=0;
                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity;                       
                      break;          
                    }
                  }                   
                  if(tempStockNum==0)
                  {
                    if(existB) { item1.disable = true;   }
                    if(existB1) { item.disable = true;  }                   
                  }
                  else
                  {
                    if(existB) { item1.disable = false;  }
                    if(existB1) { item.disable = false;  }                    
                  }     
               });
             });
          }
        }
        if(count==3)
        {  
          for(var i=0;i<this.frontendPropertyInfo.length;i++)
          {
            for(var j=0;j<this.frontendPropertyInfo[i].propertyDetails.length;j++)
            {
              this.frontendPropertyInfo[i].propertyDetails[j].disable=false;
            }
          }
          var main = this.frontendPropertyInfo[0].propertyDetails;
          var main1 = this.frontendPropertyInfo[1].propertyDetails;
          var main2 = this.frontendPropertyInfo[2].propertyDetails;
          var productPropertys = [];
             for (var i = 0; i < product.productSpecs.length; i++) 
              {
                var tmp = []
                for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) { tmp.push(product.productSpecs[i].productPropertyInfo[y].vid); }
                if(product.productSpecs[i].quantity>0)
                {
                   productPropertys.push(tmp);
                }                
              }            
          if(this.selectIndexArray.length==1)
          {  
             var exist = main.find((p) => p.id==this.selectIdAttrray[0]);
             var exist1 = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             var exist2 = main2.find((p) => p.id ==this.selectIdAttrray[0]);        
             var recordIds = [];   
             main.forEach(item=>{                  
               var tempItemId  = this.selectIdAttrray[0];
               if(exist&&item.id!=tempItemId){ return;}           
               if(!exist) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = this.selectIdAttrray[0];
                 if(exist1&&item1.id!=tempItem1Id){ return;}
                 if(!exist1) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = this.selectIdAttrray[0];
                  if(exist2&&item2.id!=tempItem2Id){ return;}
                  if(!exist2) {tempItem2Id = item2.id;};                
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);

                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }          
                 
                  if(tempStockNum==0)
                  {
                    if(recordIds.indexOf(item.id)<0)item.disable = true; 
                    if(recordIds.indexOf(item1.id)<0)item1.disable = true; 
                    if(recordIds.indexOf(item2.id)<0)item2.disable = true; 
                  }
                  else
                  {
                    if(recordIds.indexOf(tempItemId)==-1) recordIds.push(tempItemId);
                    if(recordIds.indexOf(tempItem1Id)==-1)recordIds.push(tempItem1Id);
                    if(recordIds.indexOf(tempItem2Id)==-1)recordIds.push(tempItem2Id);       
                    if(recordIds.indexOf(item.id)!=-1) item.disable=false;
                    if(recordIds.indexOf(item1.id)!=-1) item1.disable=false;
                    if(recordIds.indexOf(item2.id)!=-1) item2.disable=false;                 
                  }
                 });
               });
             });       
          }
          if(this.selectIndexArray.length==2)          
          {            
             var existA = main.find((p) => p.id==this.selectIdAttrray[0]);           
             var existB = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             var existC = main2.find((p) => p.id ==this.selectIdAttrray[0]);

             var existA1 = main.find((p) => p.id==this.selectIdAttrray[1]);         
             var existB1 = main1.find((p) => p.id ==this.selectIdAttrray[1]);
             var existC1 = main2.find((p) => p.id ==this.selectIdAttrray[1]); 

             var tempId  = this.selectIdAttrray[0]; 
             var temp1Id = this.selectIdAttrray[1];             
             var recordIds = [];   
             var disRecordIds = [];
             main.forEach(item=>{                  
               var tempItemId  = tempId;
               if(existA&&item.id!=tempItemId){ return;}           
               if(!existA) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = tempId;
                 if(existB&&item1.id!=tempItem1Id){ return;}
                 if(!existB) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = tempId;
                  if(existC&&item2.id!=tempItem2Id){ return;}
                  if(!existC) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }   
                 
                  if(tempStockNum==0)
                  {       
                    if(recordIds.indexOf(item.id)<0){item.disable = true; disRecordIds.push(item.id);}
                    if(recordIds.indexOf(item1.id)<0){item1.disable = true; disRecordIds.push(item1.id);}
                    if(recordIds.indexOf(item2.id)<0) {item2.disable = true; disRecordIds.push(item2.id); } 
                  }
                  else
                  {                    
                    if(recordIds.indexOf(tempItemId)==-1) recordIds.push(tempItemId);
                    if(recordIds.indexOf(tempItem1Id)==-1)recordIds.push(tempItem1Id);
                    if(recordIds.indexOf(tempItem2Id)==-1)recordIds.push(tempItem2Id);       
                    if(recordIds.indexOf(item.id)!=-1) item.disable=false;
                    if(recordIds.indexOf(item1.id)!=-1)item1.disable=false;
                    if(recordIds.indexOf(item2.id)!=-1)item2.disable=false;
                  }
                 });
               });
             });    
             for(var i=0;i<disRecordIds.length;i++)         
             {
                if(recordIds.indexOf(disRecordIds[i])!=-1)              
                {
                   disRecordIds.splice(i,1);
                   i--;
                }
             }
             var recordIds1 = [];   
             main.forEach(item=>{                  
               var tempItemId  = temp1Id;
               if(existA1&&item.id!=tempItemId){ return;}           
               if(!existA1) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = temp1Id;
                 if(existB1&&item1.id!=tempItem1Id){ return;}
                 if(!existB1) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = temp1Id;
                  if(existC1&&item2.id!=tempItem2Id){ return;}
                  if(!existC1) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }                    
                  if(tempStockNum==0)
                  {       
                    if(recordIds1.indexOf(item.id)<0)item.disable = true; 
                    if(recordIds1.indexOf(item1.id)<0)item1.disable = true; 
                    if(recordIds1.indexOf(item2.id)<0)item2.disable = true;                   
                  }
                  else
                  {                    
                    if(recordIds1.indexOf(tempItemId)==-1) recordIds1.push(tempItemId);
                    if(recordIds1.indexOf(tempItem1Id)==-1)recordIds1.push(tempItem1Id);
                    if(recordIds1.indexOf(tempItem2Id)==-1)recordIds1.push(tempItem2Id);       
                    if(recordIds1.indexOf(item.id)!=-1&&disRecordIds.indexOf(item.id)==-1) item.disable=false;
                    if(recordIds1.indexOf(item1.id)!=-1&&disRecordIds.indexOf(item1.id)==-1)item1.disable=false;
                    if(recordIds1.indexOf(item2.id)!=-1&&disRecordIds.indexOf(item2.id)==-1)item2.disable=false;
                  }
                 });
               });
             });     
          }
          if(this.selectIndexArray.length==3)          
          {            
             var existA = main.find((p) => p.id==this.selectIdAttrray[0]);           
             var existB = main1.find((p) => p.id ==this.selectIdAttrray[0]);
             var existC = main2.find((p) => p.id ==this.selectIdAttrray[0]);  
             var existA1 = main.find((p) => p.id==this.selectIdAttrray[1]);         
             var existB1 = main1.find((p) => p.id ==this.selectIdAttrray[1]);
             var existC1 = main2.find((p) => p.id ==this.selectIdAttrray[1]);
             var existA2 = main.find((p) => p.id==this.selectIdAttrray[2]);         
             var existB2 = main1.find((p) => p.id ==this.selectIdAttrray[2]);
             var existC2 = main2.find((p) => p.id ==this.selectIdAttrray[2]);

             var tempId  = this.selectIdAttrray[0]; 
             var temp1Id = this.selectIdAttrray[1];     
             var temp2Id = this.selectIdAttrray[2];   
             var recordIds = [];   
             var disRecordIds = [];
             main.forEach(item=>{                  
               var tempItemId  = tempId;
               if(existA&&item.id!=tempItemId){ return;}           
               if(!existA) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = tempId;
                 if(existB&&item1.id!=tempItem1Id){ return;}
                 if(!existB) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = tempId;
                  if(existC&&item2.id!=tempItem2Id){ return;}
                  if(!existC) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }   
                 
                  if(tempStockNum==0)
                  {       
                    if(recordIds.indexOf(item.id)<0){item.disable = true; disRecordIds.push(item.id);}
                    if(recordIds.indexOf(item1.id)<0){item1.disable = true; disRecordIds.push(item1.id);}
                    if(recordIds.indexOf(item2.id)<0) {item2.disable = true; disRecordIds.push(item2.id); } 
                  }
                  else
                  {                    
                    if(recordIds.indexOf(tempItemId)==-1) recordIds.push(tempItemId);
                    if(recordIds.indexOf(tempItem1Id)==-1)recordIds.push(tempItem1Id);
                    if(recordIds.indexOf(tempItem2Id)==-1)recordIds.push(tempItem2Id);       
                    if(recordIds.indexOf(item.id)!=-1) item.disable=false;
                    if(recordIds.indexOf(item1.id)!=-1)item1.disable=false;
                    if(recordIds.indexOf(item2.id)!=-1)item2.disable=false;
                  }
                 });
               });
             });      
             debugger;     
             for(var i=0;i<disRecordIds.length;i++)         
             {
                if(recordIds.indexOf(disRecordIds[i])!=-1)              
                {
                   disRecordIds.splice(i,1);
                   i--;
                }
             }
             var recordIds1 = [];   
             var disRecordIds1 = [];
             main.forEach(item=>{                  
               var tempItemId  = temp1Id;
               if(existA1&&item.id!=tempItemId){ return;}           
               if(!existA1) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = temp1Id;
                 if(existB1&&item1.id!=tempItem1Id){ return;}
                 if(!existB1) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = temp1Id;
                  if(existC1&&item2.id!=tempItem2Id){ return;}
                  if(!existC1) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }                    
                  if(tempStockNum==0)
                  {       
                    if(recordIds1.indexOf(item.id)<0){item.disable = true; disRecordIds1.push(item.id);}
                    if(recordIds1.indexOf(item1.id)<0){item1.disable = true; disRecordIds1.push(item1.id);}
                    if(recordIds1.indexOf(item2.id)<0){item2.disable = true; disRecordIds1.push(item2.id);}
                  }
                  else
                  {                    
                    if(recordIds1.indexOf(tempItemId)==-1) recordIds1.push(tempItemId);
                    if(recordIds1.indexOf(tempItem1Id)==-1)recordIds1.push(tempItem1Id);
                    if(recordIds1.indexOf(tempItem2Id)==-1)recordIds1.push(tempItem2Id);       
                    if(recordIds1.indexOf(item.id)!=-1&&disRecordIds.indexOf(item.id)==-1) item.disable=false;
                    if(recordIds1.indexOf(item1.id)!=-1&&disRecordIds.indexOf(item1.id)==-1)item1.disable=false;
                    if(recordIds1.indexOf(item2.id)!=-1&&disRecordIds.indexOf(item2.id)==-1)item2.disable=false;
                  }
                 });
               });
             });  
             debugger;
             for(var i=0;i<disRecordIds1.length;i++)         
             {
                if(recordIds1.indexOf(disRecordIds1[i])!=-1)              
                {
                   disRecordIds1.splice(i,1);
                   i--;
                }
             }          
             var recordIds2 = [];   
             main.forEach(item=>{                  
               var tempItemId  = temp2Id;
               if(existA2&&item.id!=tempItemId){ return;}           
               if(!existA2) { tempItemId = item.id;}           
               main1.forEach(item1=>{
                 var tempItem1Id = temp2Id;
                 if(existB2&&item1.id!=tempItem1Id){ return;}
                 if(!existB2) {tempItem1Id = item1.id;};               
                 main2.forEach(item2=>{
                  var tempItem2Id = temp2Id;
                  if(existC2&&item2.id!=tempItem2Id){ return;}
                  if(!existC2) {tempItem2Id = item2.id;};       
                  var tempselectAttrid=[];
                  tempselectAttrid.push(tempItemId);
                  tempselectAttrid.push(tempItem1Id);
                  tempselectAttrid.push(tempItem2Id);                      
                  var tempStockNum=0;
                  for(var i=0;i<productPropertys.length;i++)
                  {
                    var tmp = productPropertys[i];
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = 1;
                      break;          
                    } 
                  }                    
                  if(tempStockNum==0)
                  {       
                    if(recordIds2.indexOf(item.id)<0){item.disable = true; }
                    if(recordIds2.indexOf(item1.id)<0){item1.disable = true;}
                    if(recordIds2.indexOf(item2.id)<0){item2.disable = true;}
                  }
                  else
                  {                    
                    if(recordIds2.indexOf(tempItemId)==-1) recordIds2.push(tempItemId);
                    if(recordIds2.indexOf(tempItem1Id)==-1)recordIds2.push(tempItem1Id);
                    if(recordIds2.indexOf(tempItem2Id)==-1)recordIds2.push(tempItem2Id);       
                    if(recordIds2.indexOf(item.id)!=-1&&disRecordIds1.indexOf(item.id)==-1&&disRecordIds.indexOf(item.id)==-1) item.disable=false;
                    if(recordIds2.indexOf(item1.id)!=-1&&disRecordIds1.indexOf(item1.id)==-1&&disRecordIds.indexOf(item1.id)==-1)item1.disable=false;
                    if(recordIds2.indexOf(item2.id)!=-1&&disRecordIds1.indexOf(item2.id)==-1&&disRecordIds.indexOf(item2.id)==-1)item2.disable=false;
                  }
                 });
               });
             });  
             for(var i=0;i<disRecordIds1.length;i++)         
             {
                if(recordIds1.indexOf(disRecordIds1[i])!=-1)              
                {
                   disRecordIds1.splice(i,1);
                   i--;
                }
             }
          }
        }
      },
      
      setSpecDisable(count)
      {

      },
      selAttr1 ()
      {},
      selAttr (index,jj) {
        var count = this.frontendPropertyInfo[index].propertyDetails.length;
        var selectIndexArray = this.selectIndexArray
        debugger;
        for (var i = 0; i < count; i++) {
            if(i==jj)
            {
              if(this.frontendPropertyInfo[index].propertyDetails[i].current==true)
              {
                this.frontendPropertyInfo[index].propertyDetails[i].current=false;
                if (selectIndexArray.indexOf(index) >-1) {
                  var tempIndex = selectIndexArray.indexOf(index);
                  selectIndexArray.splice(tempIndex,1)
                }
              }
              else
              {
                this.frontendPropertyInfo[index].propertyDetails[i].current=true;
                if (selectIndexArray.indexOf(index) < 0) {
                  selectIndexArray.push(index)
                }
              }
            }
            else
            {
              this.frontendPropertyInfo[index].propertyDetails[i].current = false;
            }
        }      
       
        var selectAttrid = []
        selectIndexArray=[];
        for (var i = 0; i < this.frontendPropertyInfo.length; i++) {
            var propertyDetails = this.frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                    if (selectIndexArray.indexOf(i) < 0) {
                    selectIndexArray.push(i)
                }
                }
            }
        }
        this.selectIdAttrray = JSON.parse(JSON.stringify(selectAttrid));
        var product = this.product

        var stockNum = this.stockNum
       
        var settlementPrice = this.settlementPrice    
        var sellPrice = this.sellPrice
        var discountAmount = this.discountAmount
        var specImage = "";
            //从原始数据中找到相应规格组
        for (var i = 0; i < product.productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
                settlementPrice = product.productSpecs[i].settlementPrice
                stockNum = product.productSpecs[i].quantity
                sellPrice = product.productSpecs[i].sellPrice
                discountAmount = product.productSpecs[i].discountAmount
                specImage = product.productSpecs[i].specImage
            }
        }
        if(!specImage)
        {
           this.small = this.currentsmall;
        }
        else
        {
          this.small = [];
          this.small.push(specImage);
        }
        if(this.small&&this.small.length>0)
        {
          this.big = this.small[0]
          this.defaultImg = this.small[0]          
        }
        this.stockNum = stockNum
        if(this.num>this.stockNum)this.num=this.stockNum;
        this.selectIndexArray = selectIndexArray       
        this.settlementPrice = settlementPrice
        this.sellPrice = sellPrice
        this.discountAmount = discountAmount;
        this.disableSpec();
        this.$forceUpdate();
      },
      showErrorMsg(msg){
        this.$message({
              message: msg,
              type: 'error',
              customClass: 'c-msg',
              duration: 1000,
              showClose: true
            })
      }
    },
    components: {      
      VideoShow,
      ImageShow
    },
    mounted() {
      window.addEventListener('scroll', this.showTop)
    },
    created () {
      let id = this.$route.query.productId
      this.productId = id;
      this._productDet()
      this._products();
      this._productEvaluates()
      this.userId = getStore('userId')      
    }
  }
</script>


// WEBPACK FOOTER //
// goodsDetails.vue?14854b9d